import React, { useEffect, useState } from 'react';
import api from '../../../../services/api';

export function useGetTurmaMedia_alunos_por_turma_no_ano() {
  const [media_alunos_por_turma_no_ano, set_media_alunos_por_turma_no_ano] = useState<any>(null);

  async function handleMedia_alunos_por_turma_no_ano(year?:string) {
    const { data } = await api.get('/reports/media_alunos_por_turma_no_ano', {
      params: {
        year,
      },
    });
    set_media_alunos_por_turma_no_ano(data);
  }

  useEffect(() => {
    handleMedia_alunos_por_turma_no_ano();
  }, []);
  return { media_alunos_por_turma_no_ano, handleMedia_alunos_por_turma_no_ano };
}
